import ic_trigger_campaign_published from "../../assets/menu/white/ic_campaign.png";
import ic_trigger_form_sent from "../../assets/menu/white/ic_form.png";
import ic_trigger_record_added from "../../assets/menu/white/ic_user.png";
import ic_trigger_field_value from "../../assets/menu/white/ic_list.png";
import ic_timeoff from "../../assets/icons/navigation-icons/white/ic_timeoff.svg";
import ic_expense from "../../assets/icons/navigation-icons/white/ic_expense.svg";
import ic_whatsapp from "../../assets/automation/actions/ic_whatsapp.png";
import ic_deals from "../../assets/menu/white/ic_deals.png";
import ic_split from "../../assets/icons/white/ic_split.png";
import ic_assign_2 from "../../assets/automation/ic_assign_2.png";

import { DKIcon, DKIcons, INPUT_VIEW_DIRECTION } from "deskera-ui-library";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import Utility, { getRandomAlphaNumericString } from "../../utility/Utility";
import AutomationService from "../../services/automation";
import {
  AUTOMATION_ACTIONS,
  AUTOMATION_ELEMENT,
  AUTOMATION_TRIGGERS,
  WAIT_INTERVALS,
  STATUS_OPTIONS,
  SPLIT_GUTTER,
  STEP_CARD_WIDTH,
  DIRECT_CHILD_ACTION_TYPES,
  EMPLOYEE_COLUMNS,
} from "./AutomationConstants";
import i18next from "i18next";
import { decodeBase64Uri } from "../../managers/common/CommonUtil";
import {INPUT_TYPE} from "../../constants/Constant";
import { parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import { TENANT, TenantService } from "../../managers/TenantManagerService";

export default class AutomationManager {
  static automationData;
  static steps = [];
  static adjacencyMatrix = {};
  static uiJson = {
    wingSpan: {},
    outerRadiusFromLeft: 0,
  };

  static connectionId = null;
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static getAllTriggers() {
    return [
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON,
        title: "Deal Won",
        children:[
          {
            elementType: AUTOMATION_ELEMENT.TRIGGER,
            type: AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON,
            title: "Pipeline",
          }
        ]
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED,
        title: "Candidate Stage Changed",
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.EXPENSE_CREATED,
        title: "Expense Created",
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED,
        title: "Time Off Created",
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED,
        title: "Invoice Created",
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT,
        title: "Date Alert Trigger"
      },
      {
        elementType: AUTOMATION_ELEMENT.TRIGGER,
        type: AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED,
        title: "Employee Added"
      }
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static getAllActions() {
    return [
      { 
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.SPLIT_WORKFLOW,
        title: "Split Path",
        logicalOperator: "and",
        successKey: null,
        failureKey: null,
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.DESIGNATION,
        title: i18next.t("JOB_TITLE"),
        logicalOperator: "and"
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.CALCULATE_COMMISSION,
        title: i18next.t("CALCULATE_COMMISSION"),
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.INVOICE_COMMISSION,
        title: i18next.t("INVOICE_COMMISSION")
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.SEND_EMAIL,
        title: "Send an e-mail",
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.LEAVE_APPROVAL,
        title: "Time Off Approval",
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.EXPENSE_APPROVAL,
        title: "Expense Approval",
      },
      {
        elementType: AUTOMATION_ELEMENT.ACTION,
        type: AUTOMATION_ACTIONS.END_WORKFLOW,
        title: "End Automation",
      },
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static getTriggerIcon(trigger) {
    let icon = ic_trigger_form_sent;
    switch (trigger) {
      case AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED:
        icon = ic_trigger_campaign_published;
        break;
      case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
        icon = ic_trigger_form_sent;
        break;
      case AUTOMATION_TRIGGERS.CONTACT_ADDED:
        icon = ic_trigger_record_added;
        break;
      case AUTOMATION_TRIGGERS.VALUE_CHANGED:
        icon = DKIcons.white.ic_edit;
        break;
    case AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED:
        icon = ic_deals;
        break;
    case AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED:
        icon = ic_timeoff;
        break;
    case AUTOMATION_TRIGGERS.EXPENSE_CREATED:
        icon = ic_expense;
        break;
    
    case AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT:
        icon = DKIcons.white.ic_notification;
          break;
      default:
        icon = ic_trigger_field_value;
        break;
    }
    return (
      <DKIcon src={icon} className="ic-s-2 bg-button p-s border-radius-m" />
    );
  }
  static getActionIcon(action) {
    let icon = DKIcons.white.ic_email;
    let color = "bg-blue";
    switch (action) {
      case AUTOMATION_ACTIONS.SEND_EMAIL:
        icon = DKIcons.white.ic_email;
        color = "bg-gray";
        break;
      case AUTOMATION_ACTIONS.SEND_SMS_MESSAGE:
        icon = DKIcons.white.ic_notification;
        color = "bg-telegram";
        break;
      case AUTOMATION_ACTIONS.SEND_WHATSAPP_MESSAGE:
        icon = ic_whatsapp;
        color = "bg-whats-app";
        break;
      case AUTOMATION_ACTIONS.DESIGNATION:
        icon = DKIcons.white.ic_user;
        color = "bg-green";
        break;
      case AUTOMATION_ACTIONS.UPDATE_CONTACT:
        icon = DKIcons.white.ic_edit;
        color = "bg-blue";
        break;
      case AUTOMATION_ACTIONS.CREATE_DEAL:
        icon = ic_deals;
        color = "bg-green";
        break;
      case AUTOMATION_ACTIONS.UPDATE_DEAL:
        icon = DKIcons.white.ic_edit;
        color = "bg-green";
        break;
      case AUTOMATION_ACTIONS.SPLIT_WORKFLOW:
        icon = ic_split;
        color = "bg-dark-gray";
        break;
      case AUTOMATION_ACTIONS.WAIT_FOR_TIME:
        icon = DKIcons.white.ic_notification;
        color = "bg-yellow";
        break;
      case AUTOMATION_ACTIONS.ASSIGN_ACCESS:
        icon = ic_assign_2;
        color = "bg-orange";
        break;
      case AUTOMATION_ACTIONS.END_WORKFLOW:
        icon = DKIcons.white.ic_warning;
        color = "bg-red";
        break;
      case AUTOMATION_ACTIONS.CALCULATE_COMMISSION:
        icon = DKIcons.white.ic_sales;
        color = "bg-blue";
        break;
      case AUTOMATION_ACTIONS.INVOICE_COMMISSION:
        icon = DKIcons.white.ic_sales;
        color = "bg-orange";
        break;
      default:
        icon = DKIcons.white.ic_email;
    }
    return (
      <DKIcon src={icon} className={"ic-s-2 p-s border-radius-m " + color} />
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static getWaitIntervals = (index, interval) =>
    `${interval} ${WAIT_INTERVALS[index]}${interval === 1 ? "" : "s"}`;

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static getDefaultActionData(action) {
    return [];
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  static addNewStep(
    stepData,
    prevStepId,
    indexToAdd = null,
    splitIndex = 0,
    isNewWaitNodeRequired = false
  ) {
    const newStepId = getRandomAlphaNumericString(24);

    if (indexToAdd !== null) {
      this.steps.splice(indexToAdd + splitIndex + 1, 0, {
        ...stepData,
        id: newStepId,
      });
    } else {
      this.steps.push({ ...stepData, id: newStepId });
    }

    this.setAdjacencyMatrix(
      prevStepId,
      newStepId,
      stepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW,
      splitIndex
    );

    if (isNewWaitNodeRequired) {
      /* Setting a default wait action (1 day) before Email based split conditions */
      const newWaitNode = AutomationManager.getAllActions().find(
        (actionData) => actionData.type === AUTOMATION_ACTIONS.WAIT_FOR_TIME
      );
      newWaitNode["configuration"] = {
        minutes: 1440,
        count: 1,
        intervalIndex: 0,
      };

      this.addNewStep(newWaitNode, prevStepId, indexToAdd, splitIndex);
    }

    this.generateUIJson();
  }

  static updateStep(stepData, indexToUpdate) {
    /* To handle edit operation on END_WORKFLOW */
    if (!stepData.id) {
      stepData.id = this.steps[indexToUpdate].id;
    }

    this.steps[indexToUpdate] = stepData;
  }

  static deleteStep(index, parentId, isLinkedParent, linkedChildType) {
    const stepData = this.steps[index];
    const stepId = stepData.id;
    const stepIdsToRemove = [stepId];

    /* If a split element node or a node linked to it is getting deleted, delete whole tree below it */
    if (
      stepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW ||
      linkedChildType === AUTOMATION_ACTIONS.SPLIT_WORKFLOW
    ) {
      const stepIdQueue = [stepId];

      while (stepIdQueue.length !== 0) {
        let tempId = stepIdQueue.shift();
        const childIds = this.adjacencyMatrix[tempId] || [];
        stepIdsToRemove.push(...childIds);
        stepIdQueue.push(...childIds);
        delete this.adjacencyMatrix[tempId];
      }

      this.adjacencyMatrix[parentId] = this.adjacencyMatrix[parentId]?.map(
        (childId) => (childId === stepId ? null : childId)
      );
    } else {
      const childId = (this.adjacencyMatrix[stepId] || [])[0];

      const subChildId =
        isLinkedParent && DIRECT_CHILD_ACTION_TYPES.includes(linkedChildType)
          ? (this.adjacencyMatrix[childId] || [])[0]
          : null;

      this.adjacencyMatrix[parentId] = this.adjacencyMatrix[parentId].map(
        (existingChildId) =>
          existingChildId === stepId ? subChildId || childId : existingChildId
      );

      delete this.adjacencyMatrix[stepId];

      if (isLinkedParent) {
        stepIdsToRemove.push(childId);
        delete this.adjacencyMatrix[childId];
      }
    }

    this.steps = this.steps.filter(
      (step) => !stepIdsToRemove.includes(step.id)
    );

    this.generateUIJson();
  }

  static getAllSteps() {
    return Utility.makeCopyOfObject(this.steps);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  /* Method for handling existing automations, 
  saved without adjacency matrix */
  static generateAdjacencyMatrix() {
    const steps = this.steps;
    const adjacencyMatrix = {};

    if (steps.length) {
      const newSteps = steps.map((step) => ({
        ...step,
        id: getRandomAlphaNumericString(24),
      }));

      for (let counter = 1; counter < newSteps.length; counter++) {
        const sourceStepId = newSteps[counter - 1].id;
        const targetStepId = newSteps[counter].id;
        adjacencyMatrix[sourceStepId] = [targetStepId];
      }

      this.steps = newSteps;
    }

    return adjacencyMatrix;
  }

  static setAdjacencyMatrix(parentId, childId, isSplitAction, childIndex) {
    if (parentId) {
      this.adjacencyMatrix[parentId] = this.adjacencyMatrix[parentId] || [];

      const existingChildId = this.adjacencyMatrix[parentId][childIndex];

      this.adjacencyMatrix[parentId][childIndex] = childId;

      /* For split action there can be 2 paths: 
          path from 0th index is taken when split condition evaluates to true (YES),
          path from 1st index is taken when split condition evaluates to false (NO) 
      */
      this.adjacencyMatrix[childId] = isSplitAction
        ? [existingChildId, null]
        : [existingChildId];
    } else {
      this.adjacencyMatrix[childId] = isSplitAction ? [null, null] : [null];
    }
  }

  static getAdjacencyMatrix() {
    return Utility.makeCopyOfObject(this.adjacencyMatrix);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  static generateUIJson() {
    this.uiJson.wingSpan = {};

    this.uiJson.outerRadiusFromLeft = this.populateWorkflowNodesWingSpan(
      this.steps[0]?.id
    );
  }

  /* 
    This method evaluates and populates inner radius for each side of a `SPLIT_WORKFLOW` type node.
  */
  static populateWorkflowNodesWingSpan(stepId, traverseRight = false) {
    if (stepId === null) return 0;

    let parentId = null,
      children = [stepId];
    /* for finding the next SPLIT_WORKFLOW type node */
    while (children && children.length < 2) {
      parentId = children[0];
      children = this.adjacencyMatrix[parentId];
    }

    if (children) {
      const innerRadiusFromleftWing =
        this.populateWorkflowNodesWingSpan(children[0], true) + 1;
      const innerRadiusFromRightWing =
        this.populateWorkflowNodesWingSpan(children[1], false) + 1;
      this.uiJson.wingSpan[parentId] = [
        innerRadiusFromleftWing,
        innerRadiusFromRightWing,
      ];

      const outerRadius =
        this.populateWorkflowNodesWingSpan(
          traverseRight ? children[1] : children[0],
          traverseRight
        ) + 1;
      return outerRadius;
    } else {
      return 0;
    }
  }

  static setupSplitActionConfigurations() {
    const parentKeyStepTypeMapping = {};

    this.steps = this.steps.map((stepData) => {
      const newStepData = Utility.makeCopyOfObject(stepData);
      parentKeyStepTypeMapping[newStepData.id] = newStepData.type;

      if (newStepData.type === AUTOMATION_ACTIONS.SPLIT_WORKFLOW) {
        const splitPathChildren = this.adjacencyMatrix[newStepData.id];
        newStepData.successKey = splitPathChildren[0] || null;
        newStepData.failureKey = splitPathChildren[1] || null;
        newStepData.logicalOperator = "and";
      }

      return newStepData;
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static isDataAvailable() {
    return !(this.automationData === null || this.automationData === undefined);
  }

  static setData(response) {
    this.automationData = response;
    if (this.isDataAvailable()) {
      const jsonData = this.getJSONData();
      this.setNewAutomationData(jsonData);
    } else {
      this.resetAllData();
    }
  }

  static setNewAutomationData(jsonData) {
    this.steps = jsonData.steps;
    this.adjacencyMatrix =
      jsonData.adjacencyMatrix || this.generateAdjacencyMatrix();
    this.generateUIJson();
  }

  static getData() {
    return this.automationData;
  }

  static resetAllData() {
    this.steps = [];
    this.adjacencyMatrix = {};
    this.uiJson = {
      wingSpan: {},
      outerRadiusFromLeft: 0,
    };
  }
  ////////////////////////////////////////////////////////////////////////////////////

  static getRecordId() {
    if (!this.isDataAvailable()) {
      return null;
    }

    return this.automationData.data._id;
  }
  ////////////////////////////////////////////////////////////////////////////////////

  static getAutomationName() {
    if (!this.isDataAvailable()) {
      return "New Automation";
    }

    return this.automationData.data.cells[
      this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.NAME)
    ];
  }

  static getWorkflowId() {
    return this.automationData.data.cells[
      this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_ID)
    ];
  }

  ////////////////////////////////////////////////////////////////////////////////////

  static getStatus() {
    if (!this.isDataAvailable()) {
      return false;
    }

    let status =
      this.automationData.data.cells[
        this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.STATUS)
      ];

    status = JSON.stringify(status);

    return status === "[1]";
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  static getJSONData() {
    if (!this.isDataAvailable()) {
      return [];
    }

    let jsonData =
      this.automationData.data.cells[
        this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.JSON_DATA)
      ];

    return Utility.decodeJSON(jsonData);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  static getRequestToSave(_data) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.NAME)] = _data.name || 'New Automation';
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.JSON_DATA)] = _data.json;
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.STATUS)] =
      STATUS_OPTIONS.ACTIVE;
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.WORKFLOW_CONNECTION_ID)] =
      this.getConnectionId();
    return data;
  }

  static getRequestToUpdate(_data) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.JSON_DATA)] = _data.json;
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.STATUS)] =
      STATUS_OPTIONS.ACTIVE;
    return data;
  }

  static getRequestToUpdateStatus(isActive) {
    let data = {};
    data[this.getColumnId(COLUMN_CODE.PEOPLE_AUTOMATION.STATUS)] =
      isActive === true ? STATUS_OPTIONS.ACTIVE : STATUS_OPTIONS.IN_ACTIVE;

    return data;
  }

  static getColumnId(columnCode) {
    return TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, columnCode);
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static fetchPageDataById(id, callback) {
    AutomationService.getData(
      id,
      (response) => {
        this.setData({ data: response });
        callback && callback();
      },
      (error) => {}
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static setConnectionId(id) {
    this.connectionId = id;
  }
  static getConnectionId() {
    return this.connectionId;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////
  static getSplitStepDimensions(splitActionId, splitLevel) {
    const gutter = Math.floor(SPLIT_GUTTER / splitLevel);

    const splitWing = this.uiJson?.wingSpan[splitActionId] || [1, 1];
    const leftWingPadding = (splitWing[0] - 1) * STEP_CARD_WIDTH + gutter;
    const rightWingPadding = (splitWing[1] - 1) * STEP_CARD_WIDTH + gutter;

    return {
      stepWidth: STEP_CARD_WIDTH + gutter,
      leftWingPadding: leftWingPadding,
      rightWingPadding: rightWingPadding,
      leftWingHangerWidth: (splitWing[0] - 1 || 0.5) * STEP_CARD_WIDTH + gutter,
      rightWingHangerWidth:
        (splitWing[1] - 1 || 0.5) * STEP_CARD_WIDTH + gutter,
      justifyWings:
        leftWingPadding === rightWingPadding
          ? "center"
          : leftWingPadding - rightWingPadding > 0
          ? "end"
          : "start",
    };
  }

    static isCommissionType(rowData) {
        let isCommissionType = false;
        const jsonDataColumnId = TableManger.getColumnId(TABLES.PEOPLE_AUTOMATION, COLUMN_CODE.PEOPLE_AUTOMATION.JSON_DATA);
        if (rowData && rowData[jsonDataColumnId]) {
            try {
                const decodedData = decodeBase64Uri(rowData[jsonDataColumnId]);
                JSON.parse(decodedData)?.steps?.forEach((step) => {
                    switch (step.type) {
                        case AUTOMATION_ACTIONS.CALCULATE_COMMISSION:
                        case AUTOMATION_ACTIONS.SEND_EMAIL:
                        case AUTOMATION_ACTIONS.INVOICE_COMMISSION:
                            isCommissionType = true;
                            break;
                        default:
                            break;
                    }
                });
            } catch { }
        }

        return isCommissionType;
    }

    static getAutomationTrigger() {
        if (this.steps?.length > 0) {
            return this.steps.find((s) => s.elementType === AUTOMATION_ELEMENT.TRIGGER);
        }
    }

    static getEmployeeProfileDateField() {
        return [{
            columnCode: "dateOfBirth",
            id: "dateOfBirth",
            name: "Date of Birth",
            customField: false
          },{
            columnCode: "dateOfJoining",
            id: "dateOfJoining",
            name: "Date of Joining",
            customField: false
          },{
            columnCode: "dateOfConfirmation",
            id: "dateOfConfirmation",
            name: "Date of Confirmation",
            customField: false
          }]
    }

    static getDateAlertFirstTriggerColumnConfig() {
        return [{
            id : "datefield",
            columnCode : "datefield",
            required: true,
            readOnly: false,
            hasError: false,
            options: AutomationManager.getEmployeeProfileDateField(),
            direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
            tooltipText: "It will have all date field in the employee<br>profile and any of it can be selected.<br>( Including custom field )",
            errMsg: "Select a valid date field",
            name: "Select date field",
            type: INPUT_TYPE.DROPDOWN,
            uiVisible: true,
            validator:["required"]
        },{
            id : "triggerOn",
            columnCode : "triggerOn",
            required: true,
            readOnly: false,
            hasError: false,
            options: [],
            direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
            tooltipText: "",
            errMsg: "",
            name: "This action must be triggered on",
            type: INPUT_TYPE.RADIO_BUTTON,
            uiVisible: true,
            radioButtons: [{
                fieldId: "yearlyBasis",
                fieldLabel: "Yearly Basis",
                infoTxt: "This means that the trigger should<br>be applicable on an yearly basis"
    
            },{
                fieldId: "specificDate",
                fieldLabel: "Specific Date",
                infoTxt: "The specific date mentioned in<br>the date field is the time when<br>the automation will be triggered."
    
            }]
        }]
    }

    static getFilterConfig() {
        let columns = parseVisibleColumnConfig(parseColumnConfig(
            TableManger.getTableColumns(TABLES.EMPLOYEE_LIST), TABLES.EMPLOYEE_LIST)
            
          );
          const filtered_fields = columns.filter((obj) => {
            return (
              obj.type &&
              obj.type !== INPUT_TYPE.BUTTON &&
              obj.type !== INPUT_TYPE.MORE &&
              (obj.allowFilter === true ||
                obj.allowFilter === undefined ||
                obj.allowFilter === null)
            );
          });
        return filtered_fields;
    }

    static removeObjectFromConfig(filterColumnConfig, key) {
        const filteredConfig = filterColumnConfig.filter(f => f.id != key);

        return filteredConfig;
    }

    static getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    static filterEmployeeColumns() {
      if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
        return EMPLOYEE_COLUMNS.filter(c => c.id !== "reportingManagerId");
      } else {
        return EMPLOYEE_COLUMNS.filter(c => c.id !== "reportingManagerName");
      }
    }
}
